import React from "react";
import {
  ComposedChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

const Linechart = prop => {
  const randomColor = () => `hsl(${Math.floor(Math.random() * 360)}, 70%, 45%)`;

  const lineConfig = {
    line7_5_9: [
      { name: "ทุนต่างประเทศ", dataKey: "total1", color: "#FA812F" },
      { name: "ทุนในประเทศ", dataKey: "total2", color: "#3E5F44" }
    ],
    line7_5_10: [
      { name: "ทุนภาครัฐ", dataKey: "total1", color: "#FA812F" },
      { name: "ทุนเอกชน", dataKey: "total2", color: "#3E5F44" }
    ],
    line7_5_11: [
      { name: "BEEN Research", dataKey: "total1", color: "#FA812F" },
      { name: "HIV Research", dataKey: "total2", color: "#3E5F44" },
      { name: "Etc.", dataKey: "total3", color: "#93DA97" }
    ]
  };

  const lines = lineConfig[prop.order] || [];

  return (
    <ResponsiveContainer width="100%" height={290}>
      <ComposedChart
        data={prop.dataLine}
        margin={{ top: 15, right: 30, left: 10, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" tickLine={false} />
        <YAxis />

        <Tooltip
          formatter={(v, n) => [`${v} เรื่อง`, n]}
          labelFormatter={y => `ปี ${y}`}
        />
        <Legend />

        {lines.map((l, i) =>
          <Line
            key={i}
            type="monotone"
            name={l.name}
            dataKey={l.dataKey}
            stroke={l.color || randomColor()}
            strokeWidth={5}
            dot={{ r: 6 }}
            activeDot={{ r: 6 }}
          />
        )}
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default Linechart;
